// deps
import { useCallback, useState } from "react";

// internal-deps
import { VALID_PAYMENT_GROUP_TYPES } from "@swiggy-private/payment-core";

// contexts
import { PaymentGroupShowMoreCtaContextValue } from "@payment-client/contexts/PaymentGroupShowMoreCtaContext";

export const usePaymentGroupShowMoreCta = (): PaymentGroupShowMoreCtaContextValue => {
    const validGroups = Object.keys(VALID_PAYMENT_GROUP_TYPES);
    const [ctaState, setCtaState] = useState<PaymentGroupShowMoreCtaContextValue["paymentGroupShowMoreCtaState"]>(() =>
        // initial cta state
        validGroups.reduce<PaymentGroupShowMoreCtaContextValue["paymentGroupShowMoreCtaState"]>((acc, current) => {
            acc[current.toUpperCase()] = true;
            return acc;
        }, {}),
    );

    const setPaymentGroupShowMoreCtaState = useCallback(
        (groupType: string, show: boolean) => {
            if (validGroups.indexOf(groupType.toUpperCase()) === -1) {
                return;
            }
            const newCtaState = {
                ...ctaState,
                [groupType.toUpperCase()]: show,
            };
            setCtaState(newCtaState);
        },
        [ctaState, validGroups],
    );

    return {
        setPaymentGroupShowMoreCtaState,
        paymentGroupShowMoreCtaState: ctaState,
    };
};
